<template>
  <div class="main">
    <!-- <div class="text">欢迎页</div> -->
    <div class="imgBox"></div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.text {
  font-size: 20px;
  margin-bottom: -40px;
  margin-top: 20px;
}
.main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.imgBox {
  height: 80vh;
  width: 80vh;
  @include bgImg("../../assets/img/welcome.png");
}
</style>
